module.exports = {
      id: "logo-anel-usage",
      viewBox: "0 0 104 116",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#logo-anel",
      toString: function () {
        return this.url;
      }
    }